/**
 * /publishers/api — partner API key console (FS-142 / DASH).
 *
 * Flat-file TanStack Router route: dots map to slashes, so
 * `publishers.api.tsx` mounts at `/publishers/api`. Delegates all rendering
 * to `PublisherApiPage` so the route file stays a thin wiring shim.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { PublisherApiPage } from "@/features/publisher-api/PublisherApiPage";

// ---------------------------------------------------------------------------
// Search params — optional `affiliateId` deep-link so admins can land on a
// pre-scoped keys table from other screens (e.g. an affiliate drilldown).
// ---------------------------------------------------------------------------

interface PublisherApiSearch {
	affiliateId?: string;
}

export const publishersApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/publishers/api",
	validateSearch: (raw: Record<string, unknown>): PublisherApiSearch => {
		const v = raw.affiliateId;
		if (typeof v === "string" && v.trim().length > 0) {
			return { affiliateId: v.trim() };
		}
		return {};
	},
	component: PublisherApiPage,
});

export default publishersApiRoute;

// Re-export for convenience so the shared router wire-up can import either
// the route or the page component from a single module path.
export { PublisherApiPage } from "@/features/publisher-api/PublisherApiPage";
